import classNames from './SkeltonLoader.module.scss';
import classes from 'classnames';

interface SkeltonLoaderProps {
  className?: string;
}

const SkeltonLoader = ({ className }: SkeltonLoaderProps) => {
  return <div className={classes(classNames.skeltonLoader, className)}></div>;
};

export default SkeltonLoader;
